import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { customersAPI } from '../../services/api';

/**
 * Live duplicate warning shown while a customer name or GST number is typed.
 */
export const SimilarCustomerWarning = ({ name, gstNumber, excludeId }) => {
  const [result, setResult] = useState(null);

  useEffect(() => {
    const term = (name || '').trim();
    if (term.length < 3 && !(gstNumber || '').trim()) { setResult(null); return undefined; }
    const timer = setTimeout(() => {
      customersAPI.similar({ name: term, gst_number: gstNumber || undefined, exclude_id: excludeId })
        .then((response) => setResult(response.data))
        .catch(() => setResult(null));
    }, 450);
    return () => clearTimeout(timer);
  }, [name, gstNumber, excludeId]);

  if (!result || result.matches.length === 0) return null;

  return (
    <div className="border border-amber-300 bg-amber-50 p-3 text-sm" data-testid="similar-customer-warning">
      <p className="flex items-center gap-2 font-medium text-amber-900">
        <AlertTriangle className="h-4 w-4" />
        {result.exact_gst ? 'A customer with this GST number already exists' : 'A very similar customer already exists'}
      </p>
      <ul className="mt-2 space-y-1">
        {result.matches.map((match) => (
          <li key={match.id} className="flex flex-wrap items-center gap-2 text-amber-900"
            data-testid={`similar-customer-${match.id}`}>
            <span className="font-mono text-xs">{match.customer_code || '—'}</span>
            <span className="font-medium">{match.name}</span>
            <span className="text-xs text-amber-700">
              {[match.city, match.country].filter(Boolean).join(', ')} · {match.reason}
            </span>
          </li>
        ))}
      </ul>
      <p className="mt-2 text-xs text-amber-800">
        Use the existing record instead of creating another one — duplicates split the inquiry and order history.
      </p>
    </div>
  );
};

export default SimilarCustomerWarning;
